/**
 * Carries the closeout row across the trip into the rebill preliminary review and back (BOPS-131).
 *
 * The period page reads its whole period from `location.state` — start and end dates, closeout
 * status, division — and `2025-08` in the review's URL cannot rebuild it: the month bounds are
 * derivable, but the status and division that gate the page's action bar are not.
 *
 * It cannot travel in router state either. The review is the plugin, and its "Back to the period"
 * button leaves via a relative `navigate('..')`, which starts a fresh history entry with no state.
 * So the row is parked here on the way in and read back on the way out.
 */
const PERIOD_HANDOFF_KEY = 'prelimReviewPeriod';

/** Park the row being opened. Storage can throw (private mode, blocked site data) — never block the navigation on it. */
export const rememberPeriod = (period: unknown): void => {
  try {
    if (period) sessionStorage.setItem(PERIOD_HANDOFF_KEY, JSON.stringify(period));
    else sessionStorage.removeItem(PERIOD_HANDOFF_KEY);
  } catch {
    //  Nothing to do: the caller still navigates, and "back" falls through to Closeout Alerts.
  }
};

/** The parked row, or null when there is none — a cold load of the review URL, or storage refused. */
export const recallPeriod = (): unknown | null => {
  try {
    const raw = sessionStorage.getItem(PERIOD_HANDOFF_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};
